import React, { useEffect, useState } from 'react'
import { Card, Form, Button, Row, Col, Spin, Table } from 'antd'
import { wtGetFromLocalStorage } from 'src/helpers/commons/LocalStorage'
import { wtApiCall, wtApiPostWithContentTypeHandling } from 'src/helpers/commons/ApiWrapper'
import { lzNotifyErrorMessageFromResult } from 'src/helpers/commons/notifications'
import WidgetBranchSelector from 'src/widgets/Selectors/WidgetBranchSelector'
import WidgetSelector from 'src/widgets/Selectors/WidgetSelector'
import BaseListing from 'src/BaseListings'
import { wtFormatMoney } from 'src/helpers/commons/utils'
import WidgetCostCenterSelector from 'src/widgets/Selectors/WidgetCostCenterSelector'
const SalaryPaymentReport = () => {
  const Base = new BaseListing()
  const [isLoading, setIsLoading] = useState(false)
  const [form] = Form.useForm()
  const [CostCenterId, setCostCenterId] = useState(0)
  const [CostCenters, setCostCenters] = useState([])
  const [CostCenterName, setCostCenterName] = useState('')
  const [reportData, setReportData] = useState([])
  const [Data, setData] = useState([])
  const [AllowancesTypes, setAllowancesTypes] = useState([])
  const [DeductionTypes, setDeductionTypes] = useState([])
  const [Months, setMonths] = useState([])
  const [month, setMonth] = useState(0)
  const [monthName, setMonthName] = useState('')
  const [Years, setYears] = useState([])
  const [year, setYear] = useState('')
  const columns = [
    {
      title: <span style={{ fontWeight: 'bold' }}>Employee Information</span>,
      children: [
        {
          title: <span style={{ fontWeight: 'bold' }}>Sr #</span>,
          dataIndex: 'sr_no',
          key: 'sr_no',
          fixed: 'left',
          width: 50,
          render: (_, __, index) => index + 1, // Generating serial numbers dynamically
        },
        {
          title: <span style={{ fontWeight: 'bold' }}>Employee ID</span>,
          dataIndex: 'employee_id',
          key: 'employee_id',
          fixed: 'left',
          width: 80,
        },
        {
          title: <span style={{ fontWeight: 'bold' }}>Employee Name</span>,
          dataIndex: 'employee',
          key: 'employee',
          fixed: 'left',
          width: 170,
          render: (employee) => `${employee?.full_name}`,
        },
        {
          title: <span style={{ fontWeight: 'bold' }}>Designation</span>,
          dataIndex: 'employee',
          key: 'employee_designation',
          fixed: 'left',
          width: 160,
          render: (employee) => employee?.designation?.name || '-',
        },
        {
          title: <span style={{ fontWeight: 'bold' }}>Department</span>,
          dataIndex: 'employee',
          key: 'employee_department',
          fixed: 'left',
          width: 160,
          render: (employee) => employee?.department?.name || '-',
        },
        {
          title: <span style={{ fontWeight: 'bold' }}>Cost Center</span>,
          dataIndex: 'employee',
          key: 'employee_cost_center',
          fixed: 'left',
          width: 110,
          render: (employee) => employee?.cost_center?.name || '-',
        },
        {
          title: <span style={{ fontWeight: 'bold' }}>Grade</span>,
          dataIndex: 'employee',
          key: 'employee',
          fixed: 'left',
          width: 75,
          render: (employee) => employee?.grade || '-',
        },
      ],
    },
    {
      title: <span style={{ fontWeight: 'bold' }}>Earnings</span>,
      children: [
        {
          title: <span style={{ fontWeight: "bold" }}>Basic Salary</span>,
          dataIndex: "basic_salary",
          key: "basic_salary",
          width:120,
          render: (basic_salary) => wtFormatMoney(basic_salary, "", false, 0),
        },
        ...AllowancesTypes.map((allowance) => ({
          title: <span style={{ fontWeight: 'bold' }}>{allowance.name}</span>,
          dataIndex: 'salary_payment_allowances',
          key: `allowance_${allowance.id}`,
          width:120,
          render: (salary_payment_allowances) => {
            const allowanceItem = salary_payment_allowances?.find(
              (a) => a.allowance_type_id === allowance.id
            );
            return allowanceItem ? wtFormatMoney(allowanceItem.amount, "", false, 0) : "-";
          },
        })),
        {
          title: <span style={{ fontWeight: "bold" }}>Gross Salary</span>,
          dataIndex: "gross_salary",
          key: "gross_salary",
          width:120,
          render: (gross_salary) => wtFormatMoney(gross_salary, "", false, 0),
        },
      ],
    },
    {
      title: <span style={{ fontWeight: 'bold' }}>Deductions</span>,
      children: [
        ...DeductionTypes.map((deduction) => ({
          title: <span style={{ fontWeight: 'bold' }}>{deduction.name}</span>,
          dataIndex: 'salary_payment_deductions',
          key: `deduction_${deduction.id}`,
          width:120,
          render: (salary_payment_deductions) => {
            const deductionItem = salary_payment_deductions?.find(
              (d) => d.deduction_type_id === deduction.id
            );
            return deductionItem ? wtFormatMoney(deductionItem.amount, "", false, 0) : "-";
          },
        })),
      ]
    },
    {
      title: <span style={{ fontWeight: 'bold' }}>Other Deductions</span>,
      dataIndex: 'variable_deductions',
      key: 'variable_deductions',
      width:120,
      render: (variable_deductions) => {
        if (!variable_deductions) return "-";

        let deductionsArray = [];
        try {
          deductionsArray = JSON.parse(variable_deductions); // Parse JSON string
        } catch (error) {
          console.error("Error parsing variable_deductions", error);
          return "-";
        }

        return deductionsArray.length > 0
          ? deductionsArray.map((deduction) => (
            <div key={deduction.id}>
              {deduction.deduction_types?.name}: {wtFormatMoney(deduction.amount, "", false, 0)}
            </div>
          ))
          : "-";
      },
    },
    {
      title: <span style={{ fontWeight: "bold" }}>Total Deduction</span>,
      dataIndex: "deduction_amount",
      key: "deduction_amount",
      width:120,
      render: (deduction_amount) => deduction_amount ? wtFormatMoney(deduction_amount, "", false, 0) : '-',
    },
    {
      title: <span style={{ fontWeight: "bold" }}>Net Salary</span>,
      children: [
        {
          title: <span style={{ fontWeight: "bold" }}></span>,
          dataIndex: "amount_paying",
          key: "amount_paying",
          width:120,
          render: (amount_paying) => wtFormatMoney(amount_paying, "", false, 0),
        },
      ],
    },
  ]

  const changeValues = (key, val) => {
    setReportData([])
    if (key === 'cost_center_id') {
      setCostCenterId(val.value)
      setCostCenterName(val.label)
    }
    if (key === 'month') {
      setMonth(val.value)
      setMonthName(val.label)
    }
  }

  const getReportData = () => {
    setIsLoading(true)
    wtApiCall(
      'reports/employee_salary_payment_report',
      {
        month: monthName,
        year: year,
        cost_center_id: CostCenterId,
      },
      'get',
      (response) => {
        setData(response.data)
        setReportData(response.data.salary_payment_details || [])
        setAllowancesTypes(response.data.salary_allowance_types || [])
        setDeductionTypes(response.data.salary_deduction_types || [])

        setIsLoading(false)
      },
      (error) => {
        lzNotifyErrorMessageFromResult(error)
        setIsLoading(false)
      },
    )
  }

  const exportToExcel = () => {
    setIsLoading(true)
    wtApiPostWithContentTypeHandling('employee_salary_payment_report/export', { data: Data })
    setIsLoading(false)
  }
  useEffect(() => {
    Base.dropdownData(
      'attendance_months,attendance_years,cost_centers',
      {},
      [setMonths, setYears, setCostCenters],
      1,
    )
  }, [])

  return (
    <div
      className="container-fluid"
      style={{ padding: '1em', backgroundColor: 'white', minHeight: '100vh' }}
    >
      <Form layout="vertical" form={form} onFinish={getReportData}>
        <Card
          title={<span style={{ fontSize: '22px', marginLeft: '40%' }}>Salary Payment Report</span>}
        >
          <Row gutter={[24, 24]}>
            <Col xs={24} sm={10} md={5}>
              <label>Month</label>
              <WidgetSelector
                options={Months}
                placeHolder="Select Month"
                onChange={(values) => changeValues('month', values)}
                selectedValue={month}
              />
            </Col>
            <Col xs={24} sm={10} md={5}>
              <label>Year</label>
              <WidgetSelector
                options={Years}
                placeHolder="Select Year"
                onChange={(values) => setYear(values.label)}
                selectedValue={year}
              />
            </Col>
            <Col xs={24} sm={10} md={5}>
              <label htmlFor=" ">Cost Center</label>
              <WidgetCostCenterSelector
                options={CostCenters}
                displayValue={CostCenterName}
                value={CostCenterId}
                placeholder="Select Cost Center"
                onChange={(values) => changeValues('cost_center_id', values)}
                reloadDropdownData={() =>
                  Base.dropdownData('cost_centers', {}, [setCostCenters], 1)
                }
              />
            </Col>
            <Col xs={24} sm={8} md={5}>
              <Button
                style={{ marginTop: 30, marginRight: 5 }}
                type="primary"
                htmlType="submit"
                disabled={isLoading}
              >
                Search
              </Button>
              <Button
                style={{ marginTop: 30, backgroundColor: '#4BB543', color: '#fff' }}
                onClick={exportToExcel}
                disabled={isLoading ? true : false}
              >
                Export
              </Button>
            </Col>
          </Row>
          <br />
          <Table
            columns={columns}
            dataSource={reportData}
            pagination={false}
            bordered
            size="small"
            rowKey="id"
            loading={{ indicator: <Spin />, spinning: isLoading }}
            scroll={{ x: "max-content", y: 600 }}
            summary={(pageData) => {

              let totalBasicSalary = pageData.reduce((sum, record) => sum + (Number(record.basic_salary) || 0), 0);
              let totalGrossSalary = pageData.reduce((sum, record) => sum + (Number(record.gross_salary) || 0), 0);
              let totalDeductionAmount = pageData.reduce((sum, record) => sum + (Number(record.deduction_amount) || 0), 0);
              let totalAmountPaying = pageData.reduce((sum, record) => sum + (Number(record.amount_paying) || 0), 0);

              let totalVariableDeductions = pageData.reduce((sum, record) => {
                if (!record.variable_deductions) return sum;

                let deductionsArray = [];
                try {
                  deductionsArray = JSON.parse(record.variable_deductions);
                } catch (error) {
                  console.error("Error parsing variable_deductions", error);
                  return sum;
                }

                let deductionsTotal = deductionsArray.reduce((dedSum, deduction) => dedSum + (Number(deduction.amount) || 0), 0);
                return sum + deductionsTotal;
              }, 0);

              return (
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0} colSpan={7} style={{ fontWeight: "bold", textAlign: "right", background: "#fff", position: "sticky", bottom: 0, zIndex: 100 }}>
                    <b>Total</b>
                  </Table.Summary.Cell>

                  <Table.Summary.Cell index={1}>
                    <b>{wtFormatMoney(totalBasicSalary, "", false, 0)}</b>
                  </Table.Summary.Cell>

                  {AllowancesTypes.map((allowance, index) => {
                    let totalAllowance = pageData.reduce((sum, record) => {
                      const allowanceItem = record.salary_payment_allowances?.find(a => a.allowance_type_id === allowance.id);
                      return sum + (allowanceItem?.amount || 0);
                    }, 0);
                    return (
                      <Table.Summary.Cell key={index} style={{ fontWeight: "bold" }}>
                        <b>{wtFormatMoney(totalAllowance, "", false, 0)}</b>
                      </Table.Summary.Cell>
                    );
                  })}
                  <Table.Summary.Cell index={2} style={{ fontWeight: "bold" }}>
                    <b>{wtFormatMoney(totalGrossSalary, "", false, 0)}</b>
                  </Table.Summary.Cell>
                  {DeductionTypes.map((deduction, index) => {
                    let totalDeduction = pageData.reduce((sum, record) => {
                      const deductionItem = record.salary_payment_deductions?.find(d => d.deduction_type_id === deduction.id);
                      return sum + (deductionItem?.amount || 0);
                    }, 0);
                    return (
                      <Table.Summary.Cell key={index} style={{ fontWeight: "bold" }}>
                        <b>{wtFormatMoney(totalDeduction, "", false, 0)}</b>
                      </Table.Summary.Cell>
                    );
                  })}
                  <Table.Summary.Cell index={3} style={{ fontWeight: "bold" }}>
                    <b>{wtFormatMoney(totalVariableDeductions, "", false, 0)}</b>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={4} style={{ fontWeight: "bold" }}>
                    <b>{wtFormatMoney(totalDeductionAmount, "", false, 0)}</b>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={5} style={{ fontWeight: "bold" }}>
                    <b>{wtFormatMoney(totalAmountPaying, "", false, 0)}</b>
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              );
            }}
          />


        </Card>
      </Form>
    </div>
  )
}

export default SalaryPaymentReport
